import { Box, styled } from '@mui/material';

export const BaseHeaderContainer = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  alignItems: 'center',
  columnGap: theme.spacing(1),
  minHeight: 50,
}));

export const StyledTabs = styled('div')({
  marginLeft: '0.8em',
  '& ul': {
    display: 'flex',
    columnGap: '0.5em',
  },
  '& li': {
    display: 'inline-block',
  },
});
